//#region src/module/format/bytes/index.ts
const BYTE_UNITS = [
	"bytes",
	"kB",
	"MB",
	"GB",
	"TB",
	"PB",
	"EB",
	"ZB",
	"YB"
];
const BIBYTE_UNITS = [
	"bytes",
	"kiB",
	"MiB",
	"GiB",
	"TiB",
	"PiB",
	"EiB",
	"ZiB",
	"YiB"
];
const BIT_UNITS = [
	"bits",
	"kbit",
	"Mbit",
	"Gbit",
	"Tbit",
	"Pbit",
	"Ebit",
	"Zbit",
	"Ybit"
];
const BIBIT_UNITS = [
	"bits",
	"kibit",
	"Mibit",
	"Gibit",
	"Tibit",
	"Pibit",
	"Eibit",
	"Zibit",
	"Yibit"
];
/**
* Convert bytes to human-readable format
*/
function formatBytes(number, options = {}) {
	const _options = {
		bits: false,
		binary: false,
		precision: 3,
		...options
	};
	const UNITS = _options.bits ? _options.binary ? BIBIT_UNITS : BIT_UNITS : _options.binary ? BIBYTE_UNITS : BYTE_UNITS;
	const isNegative = number < 0;
	const prefix = isNegative ? "-" : "";
	let _number = isNegative ? -number : number;
	if (_number < 1) {
		const unit$1 = UNITS[0];
		return {
			prefix,
			number: _number,
			unit: unit$1,
			string: `${prefix}${_number} ${unit$1}`
		};
	}
	if (!_options.exponent) _options.exponent = Math.min(Math.floor(_options.binary ? Math.log(_number) / Math.log(1024) : Math.log10(_number) / 3), UNITS.length - 1);
	_number = Number((_number / (_options.binary ? 1024 : 1e3) ** _options.exponent).toPrecision(_options.precision));
	const unit = UNITS[_options.exponent];
	return {
		prefix,
		number: _number,
		unit,
		string: `${prefix}${_number} ${unit}`
	};
}

//#endregion
export { formatBytes };